import { SET_ERROR, SET_LIST, SET_ITEM, SET_LOADING } from '../Actions/client';
import Client from '../Entities/Client';

interface IState {
    item: Client | null;
    list: Client[],
    currentPage: number,
    pages: number;
    error: string | null;
    isLoading: boolean;
};

const defaultState = {
    item: null,
    list: [],
    error: null,
    isLoading: false,
    pages: 0,
    currentPage: 0
};

export default function newsSource(state: IState = defaultState, action: any) {
    switch (action.type) {
        case SET_LIST:
            return {
                ...state,
                list: action.data,
                pages: action.pages,
                currentPage: action.currentPage,
                isLoading: false
            };

        case SET_ERROR:
            return {
                ...state,
                error: action.error,
                isLoading: false
            };
        case SET_LOADING:
            return {
                ...state,
                isLoading: action.isLoading
            }
        case SET_ITEM:
            return {
                ...state,
                item: action.item,
                isLoading: false
            }
        default:
            return state;
    }
}
